// extracted by mini-css-extract-plugin
module.exports = {"section":"xdyfE","title":"cE8U5","input":"_2W5S4","button":"_3JyZZ","popB":"_1W3XO","white":"_2jKe_","error":"_3Ya1o"};